import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const saveAllProductSolutionsFeatureKey = 'saveAllProductSolutions';

export interface saveProductSolutionsState {
  saveAllProductSolutions: any;
  saveAllProductSolutionsResponse: any;
  saveAllProductSolutionsFailure: any;
  loaded: boolean;
}

export const initialState: saveProductSolutionsState = {
  saveAllProductSolutions: undefined,
  saveAllProductSolutionsResponse: undefined,
  saveAllProductSolutionsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.saveAllProductSolutions, (state, action) => ({
    ...state,
    loadLegalEntitiesList: action.request
  })),
  on(actions.saveAllProductSolutionsSuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesListResponse: action.response,
    loaded: true
  })),
  on(actions.saveAllProductSolutionsFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesListFailure: action.error
  }))
);

export const getsaveProductSolutions = (state: saveProductSolutionsState) => state.saveAllProductSolutionsResponse;

export const getsaveProductSolutionsIsLoaded = (state: saveProductSolutionsState) => state.loaded;
